var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      attrs: { widget: { title: "Call Flows", iconClass: "fa fa-sitemap" } },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              _c("div", { staticClass: "header-extra" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.name.value,
                      expression: "filters.name.value"
                    }
                  ],
                  staticClass:
                    "form-control input-md widget-header-input m-r-10",
                  attrs: {
                    type: "search",
                    placeholder: _vm.$t("SEARCH_CALL_FLOWS")
                  },
                  domProps: { value: _vm.filters.name.value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.filters.name, "value", $event.target.value)
                    }
                  }
                })
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [_vm._v(" "), _c("CallFlowsView", { attrs: { filters: _vm.filters } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }